import React, { Component } from 'react';

export class Blank extends Component {
  render() {
    return <div className='blank' />;
  }
}
